import requests from './httpService';

/**
 * Normalize domain for Origin Master.
 * Keeps host:port (e.g. localhost:3000). Strips protocol, www, and path.
 */
export const normalizeDomainName = (value) => {
  let domain = String(value || '')
    .trim()
    .toLowerCase();
  if (!domain) return '';

  try {
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(domain)) {
      const parsed = new URL(domain);
      domain = parsed.host || parsed.hostname || domain;
    } else if (domain.includes('/') && !/\s/.test(domain)) {
      const parsed = new URL(`http://${domain}`);
      domain = parsed.host || parsed.hostname || domain;
    }
  } catch {
    // fall through
  }

  domain = domain.replace(/^www\./, '').split('/')[0].split('?')[0].trim();

  if (domain.startsWith('[')) {
    return domain;
  }

  const hostPort = domain.match(/^([a-z0-9.-]+)(?::(\d{1,5}))?$/);
  if (hostPort) {
    return hostPort[2] ? `${hostPort[1]}:${hostPort[2]}` : hostPort[1];
  }

  domain = domain.replace(/[^a-z0-9.:-]/g, '');
  domain = domain.replace(/^\.+|\.+$/g, '');
  return domain;
};

const OriginMasterService = {
  getAllOriginMaster(body = {}) {
    return requests.post(`/originmaster/list`, body);
  },
  findOriginMasterList(body = {}) {
    return requests.post(`/originmaster/find`, body);
  },
  /** Public: features configured for a domain (from URL host). */
  getFeaturesByDomain(domainName) {
    const q = encodeURIComponent(normalizeDomainName(domainName) || String(domainName || '').trim());
    return requests.get(`/originmaster/features?domainName=${q}`);
  },
  createOriginMaster(body) {
    return requests.post('/originmaster/add', body);
  },
  getOriginMasterById(id) {
    return requests.get(`/originmaster/${encodeURIComponent(String(id))}`);
  },
  updateOriginMaster(id, body) {
    return requests.put(`/originmaster/${encodeURIComponent(String(id))}`, body);
  },
  deleteOriginMaster(id) {
    return requests.delete(`/originmaster/${encodeURIComponent(String(id))}`);
  },
};

export default OriginMasterService;
